import { Group, Text, ActionIcon, Menu } from '@mantine/core';
import { IconMenu2, IconLogout, IconUser } from '@tabler/icons-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/features/auth/store/authStore';
import { useLogout } from '@/features/auth/hooks/useAuth';
import { capitalizeName } from '@/utils/name';

/**
 * Mobile Header Component
 *
 * Top header bar for mobile layout
 * - Shows page title based on route
 * - Notifications icon
 * - Menu with user actions
 */
export function MobileHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const handleLogout = useLogout();
  const user = useAuthStore((state) => state.user);

  // Determine page title from route
  const getPageTitle = () => {
    const path = location.pathname;

    if (path === '/') return 'Home';
    if (path.startsWith('/parent/children') || path.startsWith('/mobile/parent/children')) return 'My Children';
    if (path.startsWith('/parent/assignments') || path.startsWith('/mobile/parent/assignments')) return 'Assignments';
    if (path.startsWith('/mobile/parent/assign') || path.startsWith('/mobile/parent/create-assignment')) return 'New Assignment';
    if (path.startsWith('/parent/child') || path.startsWith('/mobile/parent/child')) return 'Child Details';
    if (path.startsWith('/parent/fluency')) return 'Read Aloud';
    if (path.startsWith('/parent') || path.startsWith('/mobile/parent')) return 'Parent Portal';
    if (path.startsWith('/library')) return 'Library';
    if (path.startsWith('/flashcards')) return 'Flashcards';
    if (path.startsWith('/assignments')) return 'Assignments';
    if (path.startsWith('/profile')) return 'Profile';
    if (path.startsWith('/analytics')) return 'Progress';

    return 'Svara';
  };

  return (
    <Group h="100%" px="md" justify="space-between">
      {/* Page Title */}
      <Text fw={600} size="lg">
        {getPageTitle()}
      </Text>

      {/* Actions */}
      <Group gap="xs">
        {/* Menu */}
        <Menu shadow="md" width={200} position="bottom-end">
          <Menu.Target>
            <ActionIcon variant="subtle" size="lg" aria-label="Menu">
              <IconMenu2 size={20} />
            </ActionIcon>
          </Menu.Target>

          <Menu.Dropdown>
            <Menu.Label>
              {capitalizeName(user?.firstName || user?.username) || 'User'}
            </Menu.Label>

            <Menu.Item
              leftSection={<IconUser size={16} />}
              onClick={() => navigate('/profile')}
            >
              Profile
            </Menu.Item>

            <Menu.Divider />

            <Menu.Item
              color="red"
              leftSection={<IconLogout size={16} />}
              onClick={handleLogout}
            >
              Logout
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>
    </Group>
  );
}
